module.exports = __webpack_public_path__ + "images/pages/for_business/sp/case4_8c6f2117a970a58f1032855eaee31d3a.png";